import type { IVariable } from "@bbj-types/utils";
import { Stack, Typography } from "@mui/material";
import { EditorV2 } from "@styleguide";

export type TFormSmsInputContentProps = {
  value: { html: string; text: string };
  onChange: (value: { html: string; text: string }) => void;
  characterLimit?: number;
  hardCharacterLimit?: boolean;
  variableList?: IVariable[];
  disabled?: boolean;
  label?: string;
};

export const FormSmsInputContent = ({
  label = "Contenu",
  value,
  onChange,
  characterLimit = 400,
  hardCharacterLimit,
  variableList,
  disabled,
}: TFormSmsInputContentProps) => {
  return (
    <Stack
      sx={{
        width: "100%",
      }}
    >
      {label && (
        <Typography variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary, mb: 1 })}>
          {label}
        </Typography>
      )}
      <EditorV2
        onChange={(html, text) => {
          const trimmedText = text === "\n" ? "" : text;
          const finalText =
            hardCharacterLimit && trimmedText.length > characterLimit
              ? trimmedText.slice(0, characterLimit)
              : trimmedText;
          onChange({ html, text: finalText });
        }}
        toolbar="variable"
        value={value.html}
        maxCharLimit={hardCharacterLimit ? characterLimit : undefined}
        init={{
          // biome-ignore lint/style/useNamingConvention: <explanation>
          max_height: 380,
        }}
        variableList={variableList}
        disabled={disabled}
      />
      <Typography
        sx={[
          {
            display: "flex",
            justifyContent: "end",
          },
          (theme) => ({ color: theme.palette.primary.light, mt: 0.5 }),
        ]}
      >
        {value.text?.length || 0}/{characterLimit} caractères
      </Typography>
    </Stack>
  );
};
